<template>
  <footer class="footer">
    <div class="ft width-a">
      <div class="left">
        <div class="txt-a">友情链接</div>
        <ul class="company">
          <li><a href="http://www.zhengzhou.gov.cn/" target="_blank">郑州市人民政府</a></li>
          <li><a href="https://zz.hnzwfw.gov.cn/" target="_blank">郑州政务服务网</a></li>
          <li><a href="http://mzj.zhengzhou.gov.cn/" target="_blank">郑州市民政局</a></li>
          <li><a href="http://zzjsj.zhengzhou.gov.cn/" target="_blank">郑州市城乡建设局</a></li>
          <li><a href="http://zzrs.zhengzhou.gov.cn/" target="_blank">郑州市人力资源和社会保障局</a></li>
          <li><a href="http://wjw.zhengzhou.gov.cn/" target="_blank">郑州市卫生健康委员会</a></li>
          <li><a href="http://zzshszh.org.cn/" target="_blank">郑州市红十字会</a></li>
          <li><a href="http://zzga.zhengzhou.gov.cn/" target="_blank">郑州市公安局</a></li>
          <li><a href="http://zzcz.zhengzhou.gov.cn/" target="_blank">郑州市财政局</a></li>
          <li><a href="http://tyj.zhengzhou.gov.cn/" target="_blank">郑州市体育局</a></li>
          <li><a href="http://zzfy.hncourt.gov.cn/" target="_blank">郑州市中级人民法院</a></li>
        </ul>
      </div>
      <ul class="right">
        <li>
          <img class="img-a" src="@/assets/qrcodea.png" alt="">
          <span class="txt-b">官方微信</span>
        </li>
        <li>
          <img class="img-a" src="@/assets/qrcodeb.png" alt="">
          <span class="txt-b">官方微博</span>
        </li>
      </ul>
    </div>
    <div class="fb">
      Copyright © 2020 郑州铁路技术学院 保留所有权利 闽ICP备05019651号-2
    </div>
  </footer>
</template>

<script>
export default {
  name: "MFooter"
};
</script>

<style scoped lang="scss">
.footer {
  background-color: #2b303b;
}
.ft {
  height: 249px;
  padding: 40px 0px 0px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.fb {
  height: 45px;
  line-height: 45px;
  color: #838487;
  font-size: 14px;
  text-align: center;
  border-top: 1px solid #525254;
}
.company {
  width: 542px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  li {
    a {
      font-size: 16px;
      color: #838487;
      line-height: 50px;
    }
  }
}
.txt-a {
  color: #cdcfd4;
  font-size: 30px;
}
.txt-b {
  font-size: 16px;
  color: #838487;
  margin: 16px 0px 0px 0px;
}
.img-a {
  width: 84px;
  height: 84px;
}
.right {
  display: flex;
  flex-direction: row;
  li {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0px 0px 0px 30px;
  }
}
</style>
